import { actions } from '../configurations/constants';

export const addConsignorList = (consignorList) => {
  return {
    type: actions.ADD_CONSIGNOR_LIST,
    payload: consignorList
  };
};

export const addConsignorGroup = (consignorGroup) => {
  return {
    type: actions.ADD_CONSIGNOR_GROUP,
    payload: consignorGroup
  };
};

export const setConsignor = (consignor) => {
  return {
    type: actions.SET_CONSIGNOR,
    payload: consignor
  };
};
